import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-iframe-modal',
  templateUrl: './iframe-modal.component.html',
  styleUrls: ['./iframe-modal.component.scss'],
  standalone: true,
  imports: [MatDialogModule, MatIconModule]
})
export class IframeModalComponent implements OnInit {
  @Input() iframeUrl: string;
  safeIframeUrl: SafeResourceUrl;
  headerName: string = "";

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private sanitizer: DomSanitizer) {
    this.iframeUrl = data.iframeUrl;
    this.safeIframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.iframeUrl);
  }

  ngOnInit(): void {
    this.headerName = "I-Vigil Cockpit"
  }

}
